import microuniversoApi from "app/api/microuniversoApi";
import globalMU from "globalMU"
import store from "app/redux/store/store";
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"

export type DefinirEntregaPosteriorItemParams = {
  identificadorItem: number;
  entregaPosterior: boolean;
  atualizarEstadoLegadoImediatamente?: boolean;
  itemOrcamentoLegado?: any;
};

export async function definirEntregaPosteriorItem(
  params: DefinirEntregaPosteriorItemParams
) {
  try {
    globalMU.blockUI();

    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirEntregaPosteriorItem(
        store.getState().orcamento.IdentificadorOrcamento,
        params.identificadorItem, 
        params.entregaPosterior)

    atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)

  } finally {
    globalMU.unblockUI();
  }
}
